export const CommentIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.99984 11.6665H14.9998V9.99984H4.99984V11.6665ZM4.99984 9.1665H14.9998V7.49984H4.99984V9.1665ZM4.99984 6.6665H14.9998V4.99984H4.99984V6.6665ZM3.33317 14.9998C2.87484 14.9998 2.48248 14.8366 2.15609 14.5103C1.8297 14.1839 1.6665 13.7915 1.6665 13.3332V3.33317C1.6665 2.87484 1.8297 2.48248 2.15609 2.15609C2.48248 1.8297 2.87484 1.6665 3.33317 1.6665H16.6665C17.1248 1.6665 17.5172 1.8297 17.8436 2.15609C18.17 2.48248 18.3332 2.87484 18.3332 3.33317V18.3332L14.9998 14.9998H3.33317Z"
      fill="currentColor"
    />
  </svg>
);
